import type { AdDetails } from '@amzn/safeframe-model';
import { ADPT_SF_HIGH_RATE_METRIC_LOGGING, ADPT_SF_LOW_RATE_METRIC_LOGGING } from '@/components/weblabs.js';
import { API_KEY } from '@/components/metrics/awsMetricLoggerApiKey.js';
import { LightAdDetails } from '@amzn/safeframe-model';
import { logMetric, PostMetricDTO } from '@/components/metrics/awsMetricBatcher.js';

type MetricInputBase = {
    metricName: string;
    count?: number;
    additionalDimensions?: Record<string, string>;
};

type MetricInputSF = MetricInputBase & {
    adDetails: AdDetails;
};

type MetricInputLA = MetricInputBase & {
    lightAdDetails: LightAdDetails;
};

/**
 * @deprecated This is not live yet. Don't use.
 * SIM: https://sim.amazon.com/issues/CPP-39529
 */
export const logHighRateMetricSF = ({
    metricName,
    adDetails,
    count = 1,
    additionalDimensions = {},
}: MetricInputSF): void => {
    if (ADPT_SF_HIGH_RATE_METRIC_LOGGING().isT1()) {
        logMetric(toPostMetricDTO(metricName, count, toSFDimensions(adDetails, additionalDimensions)));
    }
};

/**
 * @deprecated This is not live yet. Don't use.
 * SIM: https://sim.amazon.com/issues/CPP-39529
 */
export const logLowRateMetricSF = ({
    metricName,
    adDetails,
    count = 1,
    additionalDimensions = {},
}: MetricInputSF): void => {
    if (ADPT_SF_LOW_RATE_METRIC_LOGGING().isT1()) {
        logMetric(toPostMetricDTO(metricName, count, toSFDimensions(adDetails, additionalDimensions)));
    }
};

/**
 * @deprecated This is not live yet. Don't use.
 * SIM: https://sim.amazon.com/issues/CPP-39529
 */
export const logHighRateMetricLA = ({
    metricName,
    lightAdDetails,
    count = 1,
    additionalDimensions = {},
}: MetricInputLA): void => {
    if (ADPT_SF_HIGH_RATE_METRIC_LOGGING().isT1()) {
        logMetric(toPostMetricDTO(metricName, count, toLADimensions(lightAdDetails, additionalDimensions)));
    }
};

/**
 * @deprecated This is not live yet. Don't use.
 * SIM: https://sim.amazon.com/issues/CPP-39529
 */
export const logLowRateMetricLA = ({
    metricName,
    lightAdDetails,
    count = 1,
    additionalDimensions = {},
}: MetricInputLA): void => {
    if (ADPT_SF_LOW_RATE_METRIC_LOGGING().isT1()) {
        logMetric(toPostMetricDTO(metricName, count, toLADimensions(lightAdDetails, additionalDimensions)));
    }
};

const toPostMetricDTO = (metricName: string, count: number, dimensions: Record<string, string>): PostMetricDTO => ({
    metricName: metricName,
    timestamp: new Date().getTime(),
    count: count,
    dimensions: dimensions,
    xApiKey: API_KEY,
});

const toSFDimensions = (adDetails: AdDetails, additionalDimensions: Record<string, string>): Record<string, string> => {
    return {
        app: 'SF',
        siteName: adDetails.siteName,
        slotName: adDetails.slotName,
        pageType: adDetails.pageType,
        placementId: adDetails.placementId,
        mediaType: adDetails.mediaType,
        programId: adDetails.adCreativeMetaData?.adProgramId,
        creativeTemplateName: adDetails.adCreativeMetaData?.adCreativeTemplateName,
        deviceType: adDetails.deviceType,
        creativeId: adDetails.adCreativeMetaData.adCreativeId,
        ...additionalDimensions,
    };
};

const toLADimensions = (
    adDetails: LightAdDetails,
    additionalDimensions: Record<string, string> | undefined,
): Record<string, string> => {
    return {
        app: 'LA',
        siteName: adDetails.siteName,
        slotName: adDetails.slotName,
        pageType: adDetails.pageType,
        placementId: adDetails.placementId,
        mediaType: adDetails.videoCreative ? 'V' : 'D',
        programId: adDetails.adCreativeMetaData?.adProgramId,
        creativeTemplateName: adDetails.adCreativeMetaData?.adCreativeTemplateName,
        deviceType: adDetails.deviceType,
        creativeId: adDetails.adCreativeMetaData.adCreativeId,
        ...additionalDimensions,
    };
};
